import GroupScreen from '../../components/layout/group-screen';
import { JOB_NAMES } from '../../constants/jobNames';
import MinistriesList from '../ministries/ministry-list';
import DepartmentsList from '../departments/department-list';
import DistrictsList from '../districts/districts-list';
import OrgStructureView from '../org-structure/org-structure-view';

const ORG_JOBS = [JOB_NAMES.MINISTRIES, JOB_NAMES.DEPARTMENTS, JOB_NAMES.DISTRICTS];

/** Organization — merged screen for the ministry -> department -> district hierarchy. */
const OrganizationGroup = () => (
  <GroupScreen
    icon="pi pi-sitemap"
    iconBgColor="bg-cyan-600"
    title="Organization"
    subtitle="Ministries, departments, districts and the org structure"
    testId="SCR-OrganizationGroup"
    tabs={[
      { key: 'ministries', header: 'Ministries', leftIcon: 'pi pi-building', jobs: [JOB_NAMES.MINISTRIES], element: <MinistriesList embedded /> },
      { key: 'departments', header: 'Departments', leftIcon: 'pi pi-sitemap', jobs: [JOB_NAMES.DEPARTMENTS], element: <DepartmentsList embedded /> },
      { key: 'districts', header: 'Districts', leftIcon: 'pi pi-globe', jobs: [JOB_NAMES.DISTRICTS], element: <DistrictsList embedded /> },
      { key: 'org-structure', header: 'Org Structure', leftIcon: 'pi pi-share-alt', jobs: ORG_JOBS, element: <OrgStructureView /> },
    ]}
  />
);

export default OrganizationGroup;
